
import React, { useState, useEffect } from 'react'
import { useDocumentVisibility } from 'ahooks';
import Icon from '../Icon'
import MobileStatusBar from '../MobileStatusBar'
import getUserInfo from '../../utils/getUserInfo'
import common from '../../utils/common'  
import goBackOrForward from '../../utils/nativeFun/goBackOrForward'
import setDarkColorModel from '../../utils/nativeFun/setDarkColorModel'
import setWhiteColorModel from '../../utils/nativeFun/setWhiteColorModel'
import _getStatusBarHeight from '../../utils/nativeFun/getStatusBarHeight'
import './index.scss'

export interface AiNavigationBarProps {
    title: string | React.ReactNode
    subtitle?: string | React.ReactNode // 副标题
    isBack?: boolean
    style?: object //style样式
    mobileStatusBarBgStyle?: any
    extra?: React.ReactNode // 表格右上角的操作区域
    onBack?: () => void // 左上角自定义返回函数
    silent?: boolean //是否沉浸式导航栏
    fontColor?: string
    orgName?: boolean
    bottomBorder?: boolean
    placeholder?: boolean
    iconStyle?: any
    theme?: string ///主题色  默认黑色
}

const _iconStyle = { fontSize: '.32rem', color: '#333' }

const silent = true

const AiNavigationBar: React.FC<AiNavigationBarProps> = ({ mobileStatusBarBgStyle = {}, style = {}, theme = 'dark', isBack = true, fontColor = '', placeholder = true, bottomBorder = true, orgName = true, title = '', ...props }) => {
    const [statusHeight, setStatusHeight] = useState<any>('0')
    const [userInfo, setUserInfo] = useState<any>({})
    const documentVisibility = useDocumentVisibility();
    const handleBack = () => {
        if( !isBack ) {
            return
        }
        if (props?.onBack) {
            props?.onBack()
            return
        }
        goBackOrForward(-1)
    }
    useEffect(() => {
        // console.log(`window?.androidNative?.setDarkColorModel`)
        // console.log(window?.androidNative?.setDarkColorModel)
        // console.log(`window?.androidNative?.setWhiteColorModel`)
        // console.log(window?.androidNative?.setWhiteColorModel)
        if( theme === 'dark') {
            setDarkColorModel()
        }else {
            setWhiteColorModel()
        }
    },[theme])
    //ios 获取手机状态栏高度

    // console.log(`statusHeightstatusHeightstatusHeight`)
    // console.log(statusHeight)
    // console.log(`statusHeightstatusHeightstatusHeight`)
    const setStatusBarHeight = (obj) => {
        const _statusHeight = obj.statusBarHeight || 0
        localStorage.setItem('statusHeight', `${_statusHeight || localStorage.getItem('statusHeight')}`)
        setStatusHeight(_statusHeight || localStorage.getItem('statusHeight'))
    }
    // 安卓获取手机状态栏高度
    const getStatusBarHeight = () => {
        // console.log(`window?.androidNative?.getStatusBarHeight`)
        // console.log(window?.androidNative?.getStatusBarHeight)
        if (window?.androidNative?.getStatusBarHeight) {
            const statusHeight = window.androidNative.getStatusBarHeight()
            // console.log(`statusHeight----------`)
            // console.log(statusHeight)
            const _statusHeight = statusHeight === 0 ? 0 : Math.ceil(statusHeight / window.devicePixelRatio)
            localStorage.setItem('statusHeight', `${_statusHeight}`)
            setStatusHeight(_statusHeight)
        }
    }
    useEffect(() => {
        setStatusHeight(localStorage.getItem('statusHeight'))
        if( !common?.isAndroid_ios() ) {
            getStatusBarHeight()
        }else {
            //获取IOS的状态栏高度
            window.setStatusBarHeight = setStatusBarHeight
            _getStatusBarHeight()
        }
        return () => {
            if (document.getElementById("technical")) {
                document.getElementById("technical").style.background = ''
            }
        }
    }, [])
    useEffect(() => {
        if( documentVisibility === 'visible' ) { 
            setUserInfo(getUserInfo())
        }
    }, [documentVisibility])
    return (
        <div>
            {/* <MobileStatusBar _style={{ 'background': '#ECEDEE', ...mobileStatusBarBgStyle }} /><MobileStatusBar placeholder _style={{ 'background': '#ECEDEE', ...mobileStatusBarBgStyle }} /> */}
            <div className={`ai-nav-bar-wrapper ${bottomBorder ? 'ai-bottom-border' : ''}`} style={{'height': !silent ? '1.1733rem' : `calc(1.1733rem + ${statusHeight}px)`,'top': `${0}px`, 'paddingTop':!silent ? '0px' : `${statusHeight}px`, ...style }}>
                <div className='nav-bar-wrapper-back' style={{'paddingTop': !silent ? '0px' : `${statusHeight}px`}} onClick={handleBack}>
                    {isBack && <Icon icon="&#xe70b;" style={{ ..._iconStyle, transform: 'rotate(180deg)', color: fontColor, ...(props.iconStyle || {}) }} />}
                </div>
                <div className='nav-bar-wrapper-title'>
                    <h1 style={{ color: fontColor }}>{title}</h1>
                    {!!props.subtitle && <p style={{ color: fontColor }}>{props.subtitle}</p>}
                    {(!props.subtitle && !!orgName && !!userInfo?.orgName) && <p style={{ color: fontColor }}>{userInfo?.orgName}</p>}
                </div>
                <div className='nav-bar-wrapper-extra' style={{'paddingTop':!silent ? '0px' : `${statusHeight}px`}}>{props?.extra}</div>
            </div>
            <div style={{ 'height': !silent ? '1.1733rem' : `calc(1.1733rem + ${statusHeight}px)`, }}></div>
        </div>
    )
}

export default AiNavigationBar

